module.exports = __webpack_public_path__ + "static/mspi-03f615e83dc0c6012e4467646f123338.jpg";